import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ArticlePage } from './pages/ArticlePage';
import { ArticlePagePT } from './pages/ArticlePagePT';
import { ArticlePageIN } from './pages/ArticlePageIN';
import { ArticlePageSP } from './pages/ArticlePageSP';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<ArticlePage data-id="element-3" />} data-id="element-2" />
        <Route path="/br" element={<ArticlePagePT data-id="element-5" />} data-id="element-4" />
        <Route path="/in" element={<ArticlePageIN data-id="element-7" />} data-id="element-6" />
        <Route path="/sp" element={<ArticlePageSP data-id="element-9" />} data-id="element-8" />
      </Routes>
    </Router>;
}